/**
 * Procurement Hub.
 *
 * Combines purchase orders and credit account management into a single
 * tabbed page. Everything related to buying and funding inventory.
 */

import { FileText, CreditCard, Building2 } from "lucide-react";
import HubTabs from "@/components/ui/HubTabs";
import { useTabState } from "@/hooks/useTabState";
import PurchaseOrdersPage from "@/pages/PurchaseOrdersPage";
import VendorsPage from "@/pages/VendorsPage";
import CreditAccountsPage from "@/pages/CreditAccountsPage";

const tabs = [
  { key: "orders", label: "Purchase Orders", icon: FileText },
  { key: "vendors", label: "Vendors", icon: Building2 },
  { key: "credit", label: "Credit Accounts", icon: CreditCard },
];

function ProcurementHub() {
  const [activeTab, setActiveTab] = useTabState("tab", "orders");

  return (
    <div className="page-wide space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-[var(--text-primary)]">
          Procurement
        </h2>
        <p className="mt-1 text-sm text-[var(--text-secondary)]">
          Purchase orders, vendor management, and credit accounts.
        </p>
      </div>

      <HubTabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

      {activeTab === "orders" && <PurchaseOrdersPage />}
      {activeTab === "vendors" && <VendorsPage />}
      {activeTab === "credit" && <CreditAccountsPage />}
    </div>
  );
}

export default ProcurementHub;
